/**
 * Include a JavaScript or CSS file dynamically
 *
 * @param {string} file
 * @returns {Promise}
 * @package stylr
 */
import includeCSS from './include-css';
import includeJS from './include-js';

export default function include( file ) {
    return file.endsWith( '.css' ) ? includeCSS( file ) : includeJS( file );
}
